import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Call_Filters } from "../../../store/actions/CommanAction";
import DataTable from "react-data-table-component";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import Loader from "../Loader/Loader";
import { customStyles } from "../Utility/Utility";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";

const TodayCallCountFilter = () => {
  const dispatch = useDispatch();
  const CallFilter = useSelector((state) => state.feedBackReducer.CallFilter);
 
  const totalAmt = CallFilter?.reduce((sum, item) => sum + (item.TotalAmt || 0), 0);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [astroName, setAstroName] = useState("");
  const [astroMobileNo, setAstroMobileNo] = useState("");
  const [userName, setUserName] = useState("");
  const [userMobileNo, setUserMobileNo] = useState("");
  const [loading, setloading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
const [showAudioModal, setShowAudioModal] = useState(false);
const [audioUrl, setAudioUrl] = useState("");


  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const defaultStartTime = `${formattedToday}`;
    const defaultEndTime = `${formattedToday}`;

    setStartTime(defaultStartTime);
    setEndTime(defaultEndTime);

    dispatch(
      Call_Filters(
        formattedToday,
        formattedToday,
        astroName,
        astroMobileNo,
        userName,
        userMobileNo,
        setloading
      )
    );
  }, [dispatch]);

  const handleSearch = () => {
    const formatDate = (dateTime) => {
      if (!dateTime) return null;
      const date = new Date(dateTime);
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    const formattedStartDate = formatDate(startTime);
    const formattedEndDate = formatDate(endTime);

    const data = {
      FromDate: formattedStartDate,
      Todate: formattedEndDate,
    };
    if (astroMobileNo.trim() && !/^\d{10}$/.test(astroMobileNo)) {
      alert("Mobile number must be exactly 10 digits and numbers.");
      return;
    }
    if (userMobileNo.trim() && !/^\d{10}$/.test(userMobileNo)) {
      alert("Mobile number must be exactly 10 digits and numbers.");
      return;
    }

    if (astroName.trim() && !/^[a-zA-Z\s]+$/.test(astroName.trim())) {
      alert("Name must be in a valid string format.");
      return;
    }
    if (userName.trim() && !/^[a-zA-Z\s]+$/.test(userName.trim())) {
      alert("Name must be in a valid string format.");
      return;
    }

    dispatch(
      Call_Filters(
        data.FromDate,
        data.Todate,
        astroName,
        astroMobileNo,
        userName,
        userMobileNo,
        setloading
      )
    );
  };

  useEffect(() => {
    if (
      astroName.length < 3 &&
      userMobileNo.length < 3 &&
      userName.length < 3 &&
      astroMobileNo.length < 3
    )
      return;

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeoutId = setTimeout(() => {
      setloading(true);
      dispatch(
        Call_Filters(
          startTime,
          endTime,
          astroName,
          astroMobileNo,
          userName,
          userMobileNo,
          setloading
        )
      );
      setloading(false);
    }, 500);

    setTimeoutId(newTimeoutId);

    return () => clearTimeout(newTimeoutId);
  }, [astroName, userMobileNo, userName, astroMobileNo]);

  const handleReset = () => {
    const today = new Date().toISOString().split("T")[0];

    setStartTime("");
    setEndTime("");
    setAstroMobileNo("");
    setAstroName("");
    setUserName("");
    setUserMobileNo("");
  };

const handlePlayRecording = async (transactionId) => {
  try {
    const res = await AddUpdate("Astrologer/StreamRecording", {
      TransactionID: transactionId
    });

    if (res?.data?.data) {
      setAudioUrl(res?.data?.data); 
      setShowAudioModal(true); 
    } else {
      swal("Oops!", "Recording not found!", "warning");
    }
  } catch (error) {
    console.error("Error playing recording:", error);
  }
};



  const columns = [
    {
      name: "User Name",
      selector: (row) => row.UserName,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.UserName}({row.UserId})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.UserMobileNo}
      </div>
        </div>
      ),
    },
    {
      name: "Astrologer Name",
      selector: (row) => row.AstrologerName,
      sortable: true,
      cell: (row) => (
        <div>
          <div>{row.AstrologerName}({row.AstroId})</div>
           <div style={{ fontSize: "12px", color: "#0b0e11ff" }}>
        {row.astromobileno}
      </div>
        </div>
      ),
    },

   
    
    {
      name: "Total Amount",
      selector: (row) => row.TotalAmt,
      sortable: true,
    },
    {
      name: "Duration(Min)",
       selector: (row) => row.Duration ? `${row.Duration} min` : "-",
      sortable: true,
    },
    {
      name: "AstroRate",
      selector: (row) => row.AstroRate,
      sortable: true,
      width: "150px",
    },
     {
      name: "Gst Amount",
      selector: (row) => row.GstAmt? row.GstAmt : "-",
      sortable: true,
      width: "100px",
    },
     {
      name: "Platform Charge",
      selector: (row) => row.PalateformCharge,
      sortable: true,
      width: "100px",
    },

   {
  name: "Date",
  selector: (row) => {
    if (!row.Datetime) return "-"; 
    const date = new Date(row.Datetime);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
    });
  },
  sortable: true,
  width: "200px",
}
,



{
  name: (
    <p className="text-end">
      Recordings
    </p>
  ),
  cell: (row) => (
    <div>
      <Dropdown drop="up">
        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                 <svg
                   width="24"
                   height="24"
                   viewBox="0 0 24 24"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                     stroke="#342E59"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                   />
                   <path
                     d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                     stroke="#342E59"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                   />
                   <path
                     d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                     stroke="#342E59"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                   />
                 </svg>
               </Dropdown.Toggle>

        <Dropdown.Menu alignRight className="dropdown-menu-right">
        

          <Dropdown.Item
  style={{ color: "black" }}
  onClick={() => handlePlayRecording(row.OrderID)}
>
  Play Recording
</Dropdown.Item>

        </Dropdown.Menu>
      </Dropdown>
    </div>
  ),
}


  ];
  return (
    <div>
      <div className="form-group main_card">
        <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Call History</h2>
        <div className="row mt-3">
          <div className="col-3">
            <label className="form-label">Start Time</label>
            <input
              type="date"
              // className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-3">
            <label className="form-label">End Time</label>
            <input
              type="date"
              // className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
          
        </div>

        <div className="row mt-3">
        <div className="col-3">
            <label className="form-label">Astrologer Name</label>
            <input
              type="text"
              // className="form-control"
              value={astroName}
              placeholder="Enter Astrologer name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setAstroName(input);
                }
              }}
            />
            {astroName.length > 0 && astroName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>
          <div className="col-3">
            <label className="form-label">Astrologer Number</label>
            <input
              type="text"
              // className="form-control"
              value={astroMobileNo}
              placeholder="Enter Astrologer number"
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,10}$/.test(input)) {
                  setAstroMobileNo(input);
                }
              }}
              maxLength={10}
            />
          </div>

          <div className="col-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
              // className="form-control"
              value={userName}
              placeholder="Enter user name"
              onChange={(e) => {
                const input = e.target.value;
                if (/^[A-Za-z\s]{0,50}$/.test(input)) {
                  setUserName(input);
                }
              }}
            />
            {userName.length > 0 && userName.length < 3 && (
              <span className="text-danger">
                Name must be at least 3 characters
              </span>
            )}
          </div>

          <div className="col-3">
            <label className="form-label">User Number</label>
            <input
              type="text"
              // className="form-control"
              value={userMobileNo}
              placeholder="Enter user Number"
              onChange={(e) => {
                const input = e.target.value;
                if (/^\d{0,10}$/.test(input)) {
                  setUserMobileNo(input);
                }
              }}
              maxLength={10}
            />
          </div>

          <button className="btn btn-primary mt-3" style={{ width: "90px" }} onClick={handleSearch}>
            Search
          </button>
          <button className="btn btn-secondary mt-3 ms-2" style={{ width: "90px" }} onClick={handleReset}>
            Reset
          </button>


        </div>


      </div>


<Modal show={showAudioModal} onHide={() => setShowAudioModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Play Recording</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    {audioUrl ? (
      <audio controls autoPlay style={{ width: "100%" }}>
        <source src={audioUrl} type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    ) : (
      <p>No recording available.</p>
    )}
  </Modal.Body>
</Modal>










      <div className="col-12 mt-2 main_card">
        {CallFilter?.length > 0 && (
          <span
            style={{
              color: "black",
              fontSize: "15px",
              margin: "20px",
              fontWeight: "bold",
            }}
          >
            Total Amount : {totalAmt}
          </span>
        )}

        {loading ? (
          <Loader />
        ) : (
          <DataTable
            dense
            data={CallFilter || []}
            columns={columns}
            selectableRowsHighlight
            pagination
            persistTableHead={true}
            noDataComponent={"There are no data to display"}
            customStyles={customStyles}
          />
        )}
      </div>
    </div>
  );
};
export default TodayCallCountFilter;
